<template>
    <t-form labelWidth="90px">
        <CptData :data="props.attribute.cptTableData" :cptDataForm="props.cptDataForm"/>
        <t-form-item label="数据类型">
          <t-radio-group variant="primary-filled" default-value="large" v-model="attribute.dataType">
            <t-radio-button value="string">字符串</t-radio-button>
            <t-radio-button value="boolean">布尔值</t-radio-button>
            <t-radio-button value="number">数字</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="开状态值">
          <t-input size="small" v-model="props.attribute.openValue" />
        </t-form-item>
        <t-form-item label="关状态值">
          <t-input size="small" v-model="props.attribute.closeValue" />
        </t-form-item>
        <t-form-item label="label">
          <t-input size="small" v-model="props.attribute.label" />
        </t-form-item>
        <t-form-item label="显示标签">
          <t-switch v-model="props.attribute.showLable" size="small" :label="['开', '关']" />
        </t-form-item>
        <template v-if="props.attribute.showLable">
          <t-form-item label="标签颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="props.attribute.labelColor" size="small" />
          </t-form-item>
          <t-form-item label="字体大小">
            <t-input-number :min="12" :max="200" v-model="props.attribute.fontSize" size="small" :decimal-places="0" />
          </t-form-item>
        </template>
        <t-form-item label="是否禁用">
            <t-switch v-model="props.attribute.disabled" size="small" :label="['开', '关']" ></t-switch>
        </t-form-item>
        <t-form-item label="尺寸">
        <t-radio-group variant="primary-filled" default-value="large" v-model="attribute.size">
          <t-radio-button value="small">小</t-radio-button>
          <t-radio-button value="medium">中</t-radio-button>
          <t-radio-button value="large">大</t-radio-button>
        </t-radio-group>
      </t-form-item>
  </t-form>
</template>

<script setup>
import CptData from '@/components/element/options/comp/cpt-data'

const props = defineProps({
  attribute: Object,
  cptDataForm: Object
})
</script>